import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Notfound from './components/Notfound';
import Websites from './components/Websites';
import Ecommerce from './components/Ecommerce';
import Customizedwebiste from './components/Customizedwebiste';
import Availablesoft from './components/Availablesoft';
import Customsoft from './components/Customsoft';
import Androidapp from './components/Androidapp';
import Iosapp from './components/Iosapp';
import Customapp from './components/Customapp';
import Socialmedia from './components/Socialmedia';
import Seo from './components/Seo';
import Contact from './components/Contact';
import Team from './components/Team';
import Career from './components/Career';
import Portfolio from './components/Portfolio';

function App() {

  return (
    <div className="wrapper">

      <Header />
      <Router>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/index' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/websites' element={<Websites />} />
          <Route path='/eccommerce-websites' element={<Ecommerce />} />
          <Route path='/customized-websites' element={<Customizedwebiste />} />
          <Route path='/available-softwares' element={<Availablesoft />} />
          <Route path='/customized-softwares' element={<Customsoft />} />
          <Route path='/android-applications' element={<Androidapp />} />
          <Route path='/ios-applications' element={<Iosapp />} />
          <Route path='/customized-applications' element={<Customapp />} />
          <Route path='/social-media-marketing' element={<Socialmedia />} />
          <Route path='/seo-optimization' element={<Seo />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/our-team' element={<Team />} />
          <Route path='/career' element={<Career />} />
          <Route path='/portfolio' element={<Portfolio />} />
          <Route path='/*' element={<Notfound />} />
        </Routes>
      </Router>
      <Footer />

    </div >
  );
}

export default App;
